import { withImageOptimizationQuery } from '@common/utils';
import { Router, useCatalogProductIdParams, usePdpBaseInfo, usePdpConfig } from '@domains/pdp-common';

import { useRollingBannerUBL } from '../log/useRollingBannerUBL';
import { getWebLandingUrl } from '../utils/url';

export const useRollingBannerService = () => {
  const { isZigzagApp } = usePdpConfig();
  const params = useCatalogProductIdParams();
  const { product } = usePdpBaseInfo(params);
  const { clickBannerUBL, impressBannerUBL } = useRollingBannerUBL();
  const handleClick = (url: string, banner_id: string, object_idx: number) => () => {
    if (isZigzagApp) {
      clickBannerUBL({ productId: product.id, objectId: banner_id, objectIdx: object_idx });
      window.location.assign(url);
    } else {
      const web_link = getWebLandingUrl(url);
      if (web_link) {
        Router.open(web_link);
      }
    }
  };

  const banner_list =
    product?.pdp_image_rolling_banner?.item_list?.map((item) => ({
      ...item,
      image_url: withImageOptimizationQuery(item.image_url, { format: 'webp', quality: 80 }) ?? item.image_url,
    })) ?? [];
  const banner_length = banner_list.length;

  return {
    is_hide: !banner_length,
    catalog_product_id: params.catalog_product_id,
    banner_list,
    handleClick,
    impressBannerUBL,
  };
};
